interface StyleObj {
  variables?: {
    [key: string]: string | number
  }
  rules?: {}
}

export const kebabCase = (string: string) =>
  string
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()

export function loadTheme(style: StyleObj) {
  if (style.variables) {
    let r = document.querySelector(':root') as HTMLElement

    if (r) {
      for (const [property, value] of Object.entries(style.variables)) {
        r.style.setProperty(`--${property}`, `${value}`)
      }
    }
  }

  if (style.rules) {
    // https://davidwalsh.name/add-rules-stylesheets

    let themeStyles = document.createElement('style')
    // WebKit hack :(
    themeStyles.appendChild(document.createTextNode(''))
    document.head.appendChild(themeStyles)

    for (const [selector, rules] of Object.entries(style.rules)) {
      themeStyles.sheet.insertRule(
        `${selector} {
                ${Object.entries(rules)
                  .map(([k, v]) => `${kebabCase(k)}:${v} !important;`)
                  .join('')}
             }`,
        0,
      )
    }
  }
}
